import React from 'react';
import LazyImage from '../components/LazyImage';
import '../styles/Services.css';

const Services = () => {
  const services = [
    { title: "PHOTOGRAPHY" },
    { title: "VIDEOGRAPHY" },
    { title: "AERIAL PHOTOGRAPHY" },
    { title: "PHOTO RETOUCHING" }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container services-container">
        <div className="services-list">
          {services.map((service, index) => (
            <div key={index} className="service-item">
              <h3 className="service-title">{service.title}</h3>
              <span className="service-arrow">↗</span>
            </div>
          ))}
        </div>

        <div className="featured-article-card">
          <div className="article-image">
            <LazyImage 
              src={require('../assets/images/s4_1.jpg')} 
              alt="Photography Equipment"
            />
          </div>
          
          <div className="article-content">
            <h3 className="article-title">
              MASTERING COMPOSITION THE KEY TO CAPTIVATING PHOTOGRAPHS
            </h3>
            <p className="article-excerpt">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque convallis, augue ut imperdiet ultricies, elit nunc viverra velit, id facilisis quam felis.
            </p>
            <a href="#insights" className="article-link">
              READ MORE <span className="arrow-right">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
